import(/* webpackMode: "eager" */ "/vercel/path0/apps/sanity-docs/app/(user)/_components/Footer/footer-nav.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["HomePageHeader"] */ "/vercel/path0/apps/sanity-docs/app/(user)/_components/HomePageHeader/HomePageHeader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NavBlur"] */ "/vercel/path0/apps/sanity-docs/app/(user)/_components/TopNav/NavBlur.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/sanity-docs/app/(user)/page.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["BentoGrid"] */ "/vercel/path0/apps/sanity-docs/app/blocks/BentoGrid/BentoGrid.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Carousel"] */ "/vercel/path0/apps/sanity-docs/app/blocks/Carousel/Carousel.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/sanity-docs/app/components/Text/text.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
